<template>
    <div class="policy" id="policy">
        <div v-for="policy in policies" :key="policy.type">
            <h2 class="policy__title">{{ policy.title }}</h2>
            <div class="policy__content" v-html="policy.content"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PolicyComponent",
    data() {
        return {
            policies: [
                {
                    type: 'privacy',
                    title: 'Política de Privacidad',
                    content: `Política de Privacidad de DataCraft

Última actualización: 18/10/2023

En DataCraft, respetamos tu privacidad y estamos comprometidos a protegerla. Esta Política de Privacidad explica qué información recopilamos, cómo la usamos y tus derechos en relación con ella.

Información del Controlador de Datos:

Nombre de la Empresa: DataCraft.
Contacto: datacraft.studios@gmail.com.
Información que Recopilamos:

Información Personal: Cuando te registras en nuestro sitio, podemos pedirte que proporciones cierta información personal como tu nombre, dirección de correo electrónico, y número de teléfono.
Información de Uso: Recopilamos información sobre cómo utilizas nuestro sitio, incluyendo las páginas que visitas y la duración de tu visita.
Bases Legales para el Procesamiento:

Procesamos tu información personal basados en tu consentimiento, y/o en nuestro interés legítimo de proporcionar y mejorar nuestro servicio.
Cómo Usamos Tu Información:

Para proporcionar y mejorar nuestro servicio.
Para comunicarnos contigo.
Transferencias Internacionales de Datos:

Actualmente, no transferimos datos personales fuera del Espacio Económico Europeo. Si esto cambia en el futuro, implementaremos las salvaguardas adecuadas y te informaremos.
Retención de Datos:

Retendremos tu información personal solo por el tiempo necesario para cumplir con los propósitos para los cuales la recopilamos.
Tus Derechos:

Tienes derecho a acceder, rectificar o borrar tu información personal.
Tienes derecho a oponerte al procesamiento de tu información personal.
Puedes retirar tu consentimiento en cualquier momento.
Cookies:

Utilizamos cookies para mejorar la experiencia del usuario y analizar el tráfico del sitio web.
Proveedores de Servicio y Terceros:

Podemos compartir tu información con proveedores de servicios de confianza que nos ayudan a operar nuestro sitio y a proporcionar nuestros servicios.
Actualizaciones de la Política de Privacidad:

Podemos actualizar esta política de privacidad ocasionalmente. Publicaremos cualquier cambio en esta página y, si son significativos, te proporcionaremos un aviso más prominente.
Contacto:

Si tienes preguntas o inquietudes sobre esta política, por favor contáctanos en datacraft.studios@gmail.com.

Al utilizar nuestro sitio web, aceptas nuestra Política de Privacidad.`  // texto de la Política de Privacidad
                },
                {
                    type: 'terms',
                    title: 'Términos de Servicio',
                    content: `Términos de Servicio de DataCraft

Última actualización: 18/10/2023

Al utilizar el sitio web de DataCraft, aceptas los siguientes términos y condiciones:

Uso del Sitio:

Aceptas usar el sitio solo para fines legales y de acuerdo con estos términos.
Contenido:

El contenido de este sitio es proporcionado "tal cual" y sin garantías de ningún tipo.
Derechos de Autor:

Todo el contenido de este sitio, incluyendo textos, gráficos, logotipos, iconos, imágenes, clips de audio y software, es propiedad de DataCraft o de sus proveedores de contenido, y está protegido por las leyes internacionales de derechos de autor.
Limitación de Responsabilidad:

DataCraft no será responsable por ningún daño directo, indirecto, incidental, especial o consecuente, o pérdida de beneficios que resulte del uso o la imposibilidad de usar este sitio.
Indemnización:

Aceptas indemnizar y mantener indemne a DataCraft, sus directores, empleados y licenciantes, contra cualquier reclamación, responsabilidad, daños, costos y gastos, incluyendo honorarios legales razonables, que surjan de tu uso del sitio, tu violación de estos términos, o tu violación de cualquier derecho de terceros.
Cambios en los Términos:

DataCraft puede modificar estos términos en cualquier momento sin previo aviso. Al continuar utilizando este sitio después de cualquier modificación, aceptas los términos modificados.
Jurisdicción y Ley Aplicable:

Estos términos se regirán e interpretarán de acuerdo con las leyes de Argentina, sin dar efecto a cualquier principio de conflictos de ley. Aceptas la jurisdicción exclusiva de los tribunales de Argentina en caso de cualquier disputa relacionada con estos términos o el uso de este sitio.
Contacto:

Si tienes alguna pregunta o inquietud sobre estos términos, por favor contáctanos en datacraft.studios@gmail.com.
Miscelánea:

Si cualquier parte de estos términos se considera inválida o inaplicable, la parte restante seguirá siendo válida y aplicable.
`  // texto de los Términos de Servicio
                }
            ]
        };
    }
}
</script>

<style scoped>
.policy {
    padding: 5px 20px 80px;
    width: 80vw !important;
    max-width: 1000px;
    margin: 100px auto;
    
    border-radius: 10px;
    border: 3px solid var(--color-accent);
}

.policy__title {
    color: var(--color-accent);

    font-family: var(--font-sans);
    font-size: 2rem;
    font-weight: bold;
    margin: 30px auto;
    text-align: center;
}

.policy__content {
    color: var(--color-accent);
text-align: start;
    font-family: var(--font-sans);
    font-size: 1rem;
    margin: 20px;
    white-space: pre-wrap; /* Esto mantendrá el formato del texto */
}
</style>
